import React, { Component } from "react";

class StoreWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    };
  }

  componentWillReceiveProps(props) {
    if (
      this.props.storeInfo &&
      props.storeInfo &&
      this.props.storeInfo.id !== props.storeInfo.id
    )
      this.setState({
        show: false
      });
  }

  hideMe() {
    this.setState({
      show: false
    });
  }

  render() {
    let { stores, storeInfo } = this.props;
    let { show } = this.state;
    let store = false;
    if (stores && storeInfo) {
      // Buscamos la tienda actualizada
      let storeAux = [
        ...stores.f1,
        ...stores.f2,
        ...stores.f3,
        ...stores.f0
      ].filter(s => s.id === storeInfo.id)[0];
      if (
        storeAux // Si existe, la seteamos
      )
        store = storeAux; // Si no, usamos la que viene de los props
      else storeAux = storeInfo;
    }
    if (show && store)
      return (
        <div className="stores-widget-container card card-1 header-form">
          <div className="pull-right" onClick={() => this.hideMe()}>
            X
          </div>
          <img alt="" src={store.imagen_listado} className="store-image pull-left" />
          <div className="mt-md-3">
            <div className="store-title">{store.title}</div>
            <div className="store-description">{store.descripcion}</div>
          </div>
          <div className="clearfix" />
        </div>
      );
    else return <div />;
  }
}

export default StoreWidget;



// WEBPACK FOOTER //
// ./src/views/StoreWidget.js